var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDeliveryguywithrack(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 985.34 1349.6",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #7441c6;\n      }\n\n      .cls-2 {\n        font-family: MyriadHebrew-Regular, 'Myriad Hebrew';\n        font-size: 18.74px;\n        letter-spacing: .09em;\n      }\n\n      .cls-2, .cls-3 {\n        fill: #fff;\n      }\n\n      .cls-4 {\n        fill: #19355a;\n      }\n\n      .cls-5 {\n        fill: #ffd6a5;\n      }\n\n      .cls-6 {\n        fill: #9559dd;\n      }\n\n      .cls-7 {\n        fill: #ecd8ff;\n      }\n\n      .cls-8 {\n        fill: #7900ff;\n      }\n\n      .cls-9 {\n        fill: #353535;\n      }\n\n      .cls-10 {\n        fill: #00c2ff;\n      }\n\n      .cls-11 {\n        fill: #ffc98e;\n      }\n\n      .cls-12 {\n        fill: #5c2bb3;\n      }\n\n      .cls-13 {\n        fill: #00203e;\n      }\n\n      .cls-14 {\n        fill: #ffb769;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Delivery_guy_with_rack",
    "data-name": "Delivery guy with rack"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Delivery_guy_with_rack-2",
    "data-name": "Delivery guy with rack"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m718.3,164.03s3.69-36.17,30.69-34.52c27,1.65,37.47,20.14,57.3,17.23,19.84-2.91,24.24,20.79,9.92,30.15,10.98,13.77,10.98,26.45-13.22,53.1-18.93,20.85-37.35,26.24-37.35,26.24-16.09,1.65-54.72-70.42-47.33-92.21Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m765.63,256.24l1.07,57.45s-35.46,4.21-50.55-9.43c11.85-37.47,16.36-61.65,16.36-61.65l33.12,13.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m718.3,164.03s-33.8,77.08-24.06,99.48c3.56,8.18,21.84,13.01,43.48,6.51,21.64-6.5,27.91-13.78,27.91-13.78,0,0-19.06-25.12-15.05-43.2,4.01-18.09,8.63-32.45,8.63-32.45,0,0-24.89-20.27-40.91-16.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "m725.35,272.77c-.33,1.23-.67,2.48-1.02,3.77,14.85-2.01,28.97-7.42,41.38-15.92l-.08-4.38c-11.95,8.67-25.76,14.33-40.28,16.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m747.05,227.03c2.06-8.23,24.05-11.1,21.99.27-1.78,9.8-15.84,14.16-24.06,12.62l2.08-12.89Z"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m690.36,398.29c-.52,2.81-1.02,5.67-1.52,8.57,5.84-10.46,12.92-24,19.59-38.96-.89-.28-1.77-.57-2.66-.85-5.14,11.5-10.54,22.18-15.41,31.24Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m957.04,1293.5l7.86,23.23c1.64.55,11.34-4.78,11.34-4.78l-8.15-21.62-11.05,3.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m945.9,1347.05c.38.77,37.55-16.71,38.32-19,.54-1.61-3.59-8.86-6.12-13.06-1.07-1.8-1.86-3.03-1.86-3.03,0,0-6.74.58-11.34,4.78,0,0-11.46,13.39-14.95,19.91-3.06,5.7-4.22,10.05-4.04,10.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m978.1,1314.98l-9.05,4.49-4.15-2.74s-23.54,23.94-23.55,25.31c0,1.37,3.33,6.72,3.33,6.72l40.66-20.16s-2.12-10.42-7.24-13.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m942.95,1345.79c.85,1.56,1.73,2.97,1.73,2.97l40.66-20.16s-.29-1.42-.91-3.37l-41.48,20.57Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m683.1,628.5s67.16,317.41,102.42,384c35.26,66.59,147.08,274.7,160.37,292.63,29.24,5.12,30.35-14.79,30.35-14.79,0,0-112.93-300.89-118.25-357.24-5.32-56.35-37.72-309.83-37.72-309.83l-137.17,5.23Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m737.84,1305.12l-2.96,24.34c1.24,1.21,12.29.6,12.29.6l1.99-23.02-11.33-1.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m704.65,1348.59c.01.86,41.08,1.17,42.77-.57,1.18-1.21.59-9.55.12-14.43-.19-2.09-.36-3.54-.36-3.54,0,0-6.33-2.39-12.29-.6,0,0-16.13,7.12-22.09,11.49-5.22,3.82-8.15,7.24-8.15,7.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m747.54,1333.6l-10.1.13-2.56-4.27s-31.58,11.41-32.17,12.64c-.59,1.23.1,7.5.1,7.5l45.38-.6s2.59-10.32-.65-15.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m702.53,1346.18c.1,1.77.28,3.42.28,3.42l45.38-.6s.35-1.41.64-3.44l-46.29.62Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m683.1,628.5s51.37,606.7,43.33,698c24.11,2.01,29.46.49,29.46.49,0,0,63.28-479.04,48.33-698.49h-121.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m785.51,1012.49c-35.26-66.59-102.42-384-102.42-384h0s.66,7.77,1.81,21.63c15.74,72.49,68,306.72,98.15,363.66,1.66,3.14,3.64,6.86,5.86,11.03.15-1.68.3-3.37.45-5.06-1.37-2.57-2.66-5.01-3.85-7.27Z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m820.27,623.26c-35.04,1.71-77.35,14.66-137.17,5.23.01-16.2-.5-33.68-1.07-51.69-1.39-43.2-3.14-89.45,1.07-128.56,5.53-51.25,15.8-92.12,23.56-117.67,5.78-19.01,10.16-29.53,10.16-29.53,0,0,8.36-1.76,19.9-3.69,8.9-1.49,19.67-3.07,29.98-4.04,1.47,2.43,2.9,4.79,4.29,7.11,47.44,78.92,51.69,97.87,49.28,322.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m798.4,387.05c-3.33,27.84-25.98,59-62.38,98.41-29.49-21.28-44.47-35.59-52.09-44.56-.15,1.23-.29,2.47-.43,3.72,8.32,9.35,23.44,23.27,50.9,43.09l2,1.44,1.67-1.81c36.04-39.03,59.64-70.89,63.14-99.91-.94-.13-1.87-.26-2.8-.39Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m681.41,557.3s46.83,10.48,139.36,0c-.06,13.49-.09,19.5-.09,19.5,0,0-50.39,13.49-139.27,0v-19.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m681.41,576.8s-2.37,157.66,17.23,338.76c37.59,26.98,97.19,0,97.19,0l-51.03-338.76h-63.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m729.06,439.66l15.75,137.14h-62.77c-1.39-43.2-3.14-89.45,1.07-128.56,5.53-51.25,15.8-92.12,23.56-117.67,10.19-15.98,20.72-26.42,30.06-33.23,16.94-12.39,29.98-12.83,29.98-12.83l4.29,15.9s-29.22,14.5-46.66,35.48c-36.93,53.97,4.73,103.77,4.73,103.77Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m586.43,270.59H6.94c-3.83,0-6.94-3.11-6.94-6.94s3.11-6.94,6.94-6.94h579.48c3.83,0,6.94,3.11,6.94,6.94s-3.11,6.94-6.94,6.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m586.43,542.8H6.94c-3.83,0-6.94-3.11-6.94-6.94s3.11-6.94,6.94-6.94h579.48c3.83,0,6.94,3.11,6.94,6.94s-3.11,6.94-6.94,6.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m586.43,815.02H6.94c-3.83,0-6.94-3.11-6.94-6.94s3.11-6.94,6.94-6.94h579.48c3.83,0,6.94,3.11,6.94,6.94s-3.11,6.94-6.94,6.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m586.43,1087.23H6.94c-3.83,0-6.94-3.11-6.94-6.94s3.11-6.94,6.94-6.94h579.48c3.83,0,6.94,3.11,6.94,6.94s-3.11,6.94-6.94,6.94Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 223.6,
    cy: 1316.65,
    r: 26.99,
    transform: "translate(-391.14 131.05) rotate(-17.77)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 223.6,
    cy: 1316.65,
    r: 17.07,
    transform: "translate(-296.52 86.59) rotate(-13.28)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 197.72,
    y: 1267.67,
    width: 13.77,
    height: 27.49
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "197.72 1295.17 220.85 1316.65 228.56 1316.65 211.49 1286.91 197.72 1295.17"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m230.21,1316.65c0-3.65-2.96-6.61-6.61-6.61s-6.61,2.96-6.61,6.61,2.96,6.61,6.61,6.61,6.61-2.96,6.61-6.61Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 518.29,
    cy: 1316.65,
    r: 26.99,
    transform: "translate(-288.64 154.3) rotate(-13.28)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 518.29,
    cy: 1316.65,
    r: 17.07,
    transform: "translate(-204.21 100.02) rotate(-9.22)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 492.4,
    y: 1267.67,
    width: 13.77,
    height: 27.49
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "492.4 1295.17 515.53 1316.65 523.24 1316.65 506.17 1286.91 492.4 1295.17"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m524.9,1316.65c0-3.65-2.96-6.61-6.61-6.61s-6.61,2.96-6.61,6.61,2.96,6.61,6.61,6.61,6.61-2.96,6.61-6.61Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m717.37,438.1s-77.68,14.62-127.66,0c-8.33,14.07-3.7,24.49-3.7,24.49,0,0,70.4,27.53,106.47,12.72,36.08-14.81,24.89-37.22,24.89-37.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m525.41,1274.62H200.51c-38.28,0-69.42-31.14-69.42-69.42V69.42C131.08,31.14,162.23,0,200.51,0h324.9c38.28,0,69.42,31.14,69.42,69.42v1135.77c0,38.28-31.14,69.42-69.42,69.42ZM200.51,13.88c-30.62,0-55.54,24.91-55.54,55.54v1135.77c0,30.62,24.92,55.54,55.54,55.54h324.9c30.62,0,55.54-24.91,55.54-55.54V69.42c0-30.62-24.92-55.54-55.54-55.54H200.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "m638.52,477.09c11.99-11.43,22.25-22.44,31.75-33.36-1.28.09-2.58.17-3.89.24-9.33,10.64-19.45,21.36-31.25,32.51,1.13.21,2.26.42,3.39.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m609.82,443.73s.37-6.29-9.52-16.91c-9.88-10.62-10.78-12.81-13.26-10.62-2.48,2.2,3.01,21.37,8.5,27.52,5.49,6.15,14.28,0,14.28,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m580.95,425.54s12.12-1.6,16.52,16.28c4.39,17.88-13.63,25.89-16.19,25.16-2.56-.73-9.11-12.89-.33-41.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m477.9,473.33s6.58-9.48-3.23-20.93c-9.81-11.45-10.29-20.78-13.42-15.87-3.13,4.91-2.12,21.16,1.89,28.57,4,7.4,13.34,11.35,14.76,8.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m394.33,1274.62H69.42c-38.28,0-69.42-31.14-69.42-69.42V69.42C0,31.14,31.14,0,69.42,0h324.9C432.61,0,463.75,31.14,463.75,69.42v1135.77c0,38.28-31.14,69.42-69.42,69.42ZM69.42,13.88c-30.62,0-55.54,24.91-55.54,55.54v1135.77c0,30.62,24.92,55.54,55.54,55.54h324.9c30.62,0,55.54-24.91,55.54-55.54V69.42c0-30.62-24.92-55.54-55.54-55.54H69.42Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m456.81,270.59H6.94c-3.83,0-6.94-3.11-6.94-6.94s3.11-6.94,6.94-6.94h449.86c3.83,0,6.94,3.11,6.94,6.94s-3.11,6.94-6.94,6.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m456.81,542.8H6.94c-3.83,0-6.94-3.11-6.94-6.94s3.11-6.94,6.94-6.94h449.86c3.83,0,6.94,3.11,6.94,6.94s-3.11,6.94-6.94,6.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m456.81,815.02H6.94c-3.83,0-6.94-3.11-6.94-6.94s3.11-6.94,6.94-6.94h449.86c3.83,0,6.94,3.11,6.94,6.94s-3.11,6.94-6.94,6.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m456.81,1087.23H6.94c-3.83,0-6.94-3.11-6.94-6.94s3.11-6.94,6.94-6.94h449.86c3.83,0,6.94,3.11,6.94,6.94s-3.11,6.94-6.94,6.94Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 95.26,
    cy: 1316.65,
    r: 26.99,
    transform: "translate(-1048.42 657.38) rotate(-55.9)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 95.26,
    cy: 1316.65,
    r: 17.07,
    transform: "translate(-209.67 32.26) rotate(-9.22)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 69.38,
    y: 1267.67,
    width: 13.77,
    height: 27.49
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "69.38 1295.17 92.51 1316.65 100.22 1316.65 83.15 1286.91 69.38 1295.17"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m101.87,1316.65c0-3.65-2.96-6.61-6.61-6.61s-6.61,2.96-6.61,6.61,2.96,6.61,6.61,6.61,6.61-2.96,6.61-6.61Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 389.95,
    cy: 1316.65,
    r: 26.99,
    transform: "translate(-816.8 661.37) rotate(-45)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 389.95,
    cy: 1316.65,
    r: 17.07,
    transform: "translate(-205.87 79.46) rotate(-9.22)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 364.06,
    y: 1267.67,
    width: 13.77,
    height: 27.49
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "364.06 1295.17 387.19 1316.65 394.9 1316.65 377.83 1286.91 364.06 1295.17"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m396.55,1316.65c0-3.65-2.96-6.61-6.61-6.61s-6.61,2.96-6.61,6.61,2.96,6.61,6.61,6.61,6.61-2.96,6.61-6.61Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m784.63,386.4s-7.61,20.11-68.22,91.71c-46.81,55.31-71.12,61.73-88.03,48.81-9.77-7.46-28.41-14.95-.21-40.25,40.34-36.19,61.44-67.49,92.24-103.69,68.12-80.07,64.22,3.42,64.22,3.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m465.38,460.27s109.22,23.66,181.83,21.51c43.01-1.27,23.22,51.3-3.72,51.02-26.94-.28-120.33-28.23-182.24-58.19l4.13-14.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m479.66,463.17s-2.67-2.95-17.39-5.69c-10.81-2.01-12.79-15.37-12.79-15.37,0,0-8.78-1.62-9.7,19.64-.54,12.44-1.82,26.07,6.7,28.65,6.83,2.06,35.61-6.28,35.61-6.28l-2.43-20.95Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m736.02,485.47c-58.57-42.26-59.94-57.05-59.94-57.05,0,0,21.22-32.74,37.22-71.86,8.59-21.01,31.66-32.84,53.36-26.19,6.93,2.13,13.49,6.06,18.64,12.76,30.62,39.84,7.25,81.14-49.27,142.34Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Inner_Delivery_Bags",
    "data-name": "Inner Delivery Bags"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "m163.45,119.91c-1.15,0-2.18-.83-2.38-2.01-3.34-19.31-11.92-32.8-20.85-32.8s-17.5,13.49-20.84,32.8c-.23,1.32-1.48,2.19-2.79,1.97-1.32-.23-2.2-1.48-1.97-2.79,8.5-49.12,42.74-49.02,51.22,0,.26,1.48-.88,2.83-2.38,2.83Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "213.66 256.7 145.31 256.7 137.4 117.49 183.38 117.49 213.66 256.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "213.66 256.7 189.58 256.7 180.28 234.47 213.66 256.7"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "43.56 256.7 62 117.49 175.47 117.49 189.71 256.7 43.56 256.7"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 143.2,
    cy: 141.1,
    r: 5.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 93.64,
    cy: 141.1,
    r: 5.8
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "m93.66,140.81c-1.31,0-2.39-1.05-2.42-2.37-.41-22.17,5.43-42.71,14.89-52.35,7.6-7.74,16.97-7.76,24.58,0,9.46,9.64,15.3,30.18,14.89,52.35-.02,1.34-1.17,2.42-2.46,2.37-1.33-.03-2.4-1.13-2.37-2.46.39-20.93-4.91-40.12-13.51-48.87-5.69-5.8-11.99-5.8-17.68,0-8.59,8.76-13.9,27.94-13.5,48.87.03,1.35-1.06,2.46-2.42,2.46Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Inner_Logo",
    "data-name": "Inner Logo"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Square",
    className: "cls-3",
    d: "m89.3,179.5v-10.72h56.06v56.06h-56.06v-9.83h-1.63v11.45h59.32v-59.32h-59.32v12.35h1.63Z"
  }), /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(86.26 203.86)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "INNER")))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "m375.69,119.91c-1.15,0-2.18-.83-2.38-2.01-3.34-19.31-11.92-32.8-20.85-32.8s-17.5,13.49-20.84,32.8c-.23,1.32-1.48,2.19-2.79,1.97-1.32-.23-2.2-1.48-1.97-2.79,8.5-49.12,42.74-49.02,51.22,0,.26,1.48-.88,2.83-2.38,2.83Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "425.9 256.7 357.56 256.7 349.65 117.49 395.62 117.49 425.9 256.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "425.9 256.7 401.83 256.7 392.52 234.47 425.9 256.7"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "255.81 256.7 274.24 117.49 387.71 117.49 401.95 256.7 255.81 256.7"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 355.45,
    cy: 141.1,
    r: 5.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 305.88,
    cy: 141.1,
    r: 5.8
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "m305.9,140.81c-1.31,0-2.39-1.05-2.42-2.37-.41-22.17,5.43-42.71,14.89-52.35,7.6-7.74,16.97-7.76,24.58,0,9.46,9.64,15.3,30.18,14.89,52.35-.02,1.34-1.17,2.42-2.46,2.37-1.33-.03-2.4-1.13-2.37-2.46.39-20.93-4.91-40.12-13.51-48.87-5.69-5.8-11.99-5.8-17.68,0-8.59,8.76-13.9,27.94-13.5,48.87.03,1.35-1.06,2.46-2.42,2.46Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Inner_Logo-2",
    "data-name": "Inner Logo"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Square-2",
    "data-name": "Square",
    className: "cls-3",
    d: "m301.55,179.5v-10.72h56.06v56.06h-56.06v-9.83h-1.63v11.45h59.32v-59.32h-59.32v12.35h1.63Z"
  }), /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(298.49 203.86)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "INNER")))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "m166.58,391.84c-1.15,0-2.18-.83-2.38-2.01-3.34-19.31-11.92-32.8-20.85-32.8s-17.5,13.49-20.84,32.8c-.23,1.32-1.48,2.19-2.79,1.97-1.32-.23-2.2-1.48-1.97-2.79,8.5-49.12,42.74-49.02,51.22,0,.26,1.48-.88,2.83-2.38,2.83Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "216.79 528.63 148.45 528.63 140.54 389.42 186.51 389.42 216.79 528.63"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "216.79 528.63 192.72 528.63 183.41 506.4 216.79 528.63"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "46.7 528.63 65.13 389.42 178.6 389.42 192.84 528.63 46.7 528.63"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 146.34,
    cy: 413.03,
    r: 5.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 96.77,
    cy: 413.03,
    r: 5.8
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "m96.79,412.74c-1.31,0-2.39-1.05-2.42-2.37-.41-22.17,5.43-42.71,14.89-52.35,7.6-7.74,16.97-7.76,24.58,0,9.46,9.64,15.3,30.18,14.89,52.35-.02,1.34-1.17,2.42-2.46,2.37-1.33-.03-2.4-1.13-2.37-2.46.39-20.93-4.91-40.12-13.51-48.87-5.69-5.8-11.99-5.8-17.68,0-8.59,8.76-13.9,27.94-13.5,48.87.03,1.35-1.06,2.46-2.42,2.46Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Inner_Logo-3",
    "data-name": "Inner Logo"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Square-3",
    "data-name": "Square",
    className: "cls-3",
    d: "m92.43,451.43v-10.72h56.06v56.06h-56.06v-9.83h-1.63v11.45h59.32v-59.32h-59.32v12.35h1.63Z"
  }), /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(89.38 475.79)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "INNER")))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "m171.07,664.34c-1.15,0-2.18-.83-2.38-2.01-3.34-19.31-11.92-32.8-20.85-32.8s-17.5,13.49-20.84,32.8c-.23,1.32-1.48,2.19-2.79,1.97-1.32-.23-2.2-1.48-1.97-2.79,8.5-49.12,42.74-49.02,51.22,0,.26,1.48-.88,2.83-2.38,2.83Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "221.28 801.13 152.94 801.13 145.03 661.92 191 661.93 221.28 801.13"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "221.28 801.13 197.21 801.13 187.9 778.9 221.28 801.13"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "51.19 801.13 69.62 661.93 183.09 661.93 197.34 801.13 51.19 801.13"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 150.83,
    cy: 685.54,
    r: 5.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 101.26,
    cy: 685.54,
    r: 5.8
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "m101.28,685.24c-1.31,0-2.39-1.05-2.42-2.37-.41-22.17,5.43-42.71,14.89-52.35,7.6-7.74,16.97-7.76,24.58,0,9.46,9.64,15.3,30.18,14.89,52.35-.02,1.34-1.17,2.42-2.46,2.37-1.33-.03-2.4-1.13-2.37-2.46.39-20.93-4.91-40.12-13.51-48.87-5.69-5.8-11.99-5.8-17.68,0-8.59,8.76-13.9,27.94-13.5,48.87.03,1.35-1.06,2.46-2.42,2.46Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Inner_Logo-4",
    "data-name": "Inner Logo"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Square-4",
    "data-name": "Square",
    className: "cls-3",
    d: "m96.93,723.93v-10.72h56.06v56.06h-56.06v-9.83h-1.63v11.45h59.32v-59.32h-59.32v12.35h1.63Z"
  }), /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(93.88 748.3)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "INNER")))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "m171.42,935.79c-1.15,0-2.18-.83-2.38-2.01-3.34-19.31-11.92-32.8-20.85-32.8s-17.5,13.49-20.84,32.8c-.23,1.32-1.48,2.19-2.79,1.97-1.32-.23-2.2-1.48-1.97-2.79,8.5-49.12,42.74-49.02,51.22,0,.26,1.48-.88,2.83-2.38,2.83Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "221.63 1072.59 153.29 1072.59 145.38 933.38 191.35 933.38 221.63 1072.59"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "221.63 1072.59 197.56 1072.59 188.25 1050.35 221.63 1072.59"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "51.54 1072.59 69.97 933.38 183.44 933.38 197.69 1072.59 51.54 1072.59"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 151.18,
    cy: 956.99,
    r: 5.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 101.61,
    cy: 956.99,
    r: 5.8
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "m101.63,956.7c-1.31,0-2.39-1.05-2.42-2.37-.41-22.17,5.43-42.71,14.89-52.35,7.6-7.74,16.97-7.76,24.58,0,9.46,9.64,15.3,30.18,14.89,52.35-.02,1.34-1.17,2.42-2.46,2.37-1.33-.03-2.4-1.13-2.37-2.46.39-20.93-4.91-40.12-13.51-48.87-5.69-5.8-11.99-5.8-17.68,0-8.59,8.76-13.9,27.94-13.5,48.87.03,1.35-1.06,2.46-2.42,2.46Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Inner_Logo-5",
    "data-name": "Inner Logo"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Square-5",
    "data-name": "Square",
    className: "cls-3",
    d: "m97.28,995.39v-10.72h56.06v56.06h-56.06v-9.83h-1.63v11.45h59.32v-59.32h-59.32v12.35h1.63Z"
  }), /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(94.23 1019.75)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "INNER")))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "m362,935.99c-1.15,0-2.18-.83-2.38-2.01-3.34-19.31-11.92-32.8-20.85-32.8s-17.5,13.49-20.84,32.8c-.23,1.32-1.48,2.19-2.79,1.97-1.32-.23-2.2-1.48-1.97-2.79,8.5-49.12,42.74-49.02,51.22,0,.26,1.48-.88,2.83-2.38,2.83Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "412.21 1072.79 343.87 1072.79 335.96 933.58 381.93 933.58 412.21 1072.79"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "412.21 1072.79 388.14 1072.79 378.83 1050.55 412.21 1072.79"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "242.12 1072.79 260.55 933.58 374.02 933.58 388.27 1072.79 242.12 1072.79"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 341.76,
    cy: 957.19,
    r: 5.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 292.19,
    cy: 957.19,
    r: 5.8
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "m292.21,956.9c-1.31,0-2.39-1.05-2.42-2.37-.41-22.17,5.43-42.71,14.89-52.35,7.6-7.74,16.97-7.76,24.58,0,9.46,9.64,15.3,30.18,14.89,52.35-.02,1.34-1.17,2.42-2.46,2.37-1.33-.03-2.4-1.13-2.37-2.46.39-20.93-4.91-40.12-13.51-48.87-5.69-5.8-11.99-5.8-17.68,0-8.59,8.76-13.9,27.94-13.5,48.87.03,1.35-1.06,2.46-2.42,2.46Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Inner_Logo-6",
    "data-name": "Inner Logo"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Square-6",
    "data-name": "Square",
    className: "cls-3",
    d: "m287.86,995.58v-10.72h56.06v56.06h-56.06v-9.83h-1.63v11.45h59.32v-59.32h-59.32v12.35h1.63Z"
  }), /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(284.81 1019.95)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "INNER")))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "m363.43,664.34c-1.15,0-2.18-.83-2.38-2.01-3.34-19.31-11.92-32.8-20.85-32.8s-17.5,13.49-20.84,32.8c-.23,1.32-1.48,2.19-2.79,1.97-1.32-.23-2.2-1.48-1.97-2.79,8.5-49.12,42.74-49.02,51.22,0,.26,1.48-.88,2.83-2.38,2.83Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "413.64 801.13 345.3 801.13 337.39 661.92 383.36 661.93 413.64 801.13"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "413.64 801.13 389.57 801.13 380.26 778.9 413.64 801.13"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "243.55 801.13 261.98 661.93 375.45 661.93 389.7 801.13 243.55 801.13"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 343.19,
    cy: 685.54,
    r: 5.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 293.62,
    cy: 685.54,
    r: 5.8
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "m293.64,685.24c-1.31,0-2.39-1.05-2.42-2.37-.41-22.17,5.43-42.71,14.89-52.35,7.6-7.74,16.97-7.76,24.58,0,9.46,9.64,15.3,30.18,14.89,52.35-.02,1.34-1.17,2.42-2.46,2.37-1.33-.03-2.4-1.13-2.37-2.46.39-20.93-4.91-40.12-13.51-48.87-5.69-5.8-11.99-5.8-17.68,0-8.59,8.76-13.9,27.94-13.5,48.87.03,1.35-1.06,2.46-2.42,2.46Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Inner_Logo-7",
    "data-name": "Inner Logo"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Square-7",
    "data-name": "Square",
    className: "cls-3",
    d: "m289.29,723.93v-10.72h56.06v56.06h-56.06v-9.83h-1.63v11.45h59.32v-59.32h-59.32v12.35h1.63Z"
  }), /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(286.24 748.3)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "INNER")))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "m367.35,392.17c-1.15,0-2.18-.83-2.38-2.01-3.34-19.31-11.92-32.8-20.85-32.8s-17.5,13.49-20.84,32.8c-.23,1.32-1.48,2.19-2.79,1.97-1.32-.23-2.2-1.48-1.97-2.79,8.5-49.12,42.74-49.02,51.22,0,.26,1.48-.88,2.83-2.38,2.83Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "417.56 528.96 349.22 528.96 341.3 389.75 387.28 389.75 417.56 528.96"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "417.56 528.96 393.49 528.96 384.18 506.72 417.56 528.96"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "247.47 528.96 265.9 389.75 379.37 389.75 393.61 528.96 247.47 528.96"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 347.1,
    cy: 413.36,
    r: 5.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 297.54,
    cy: 413.36,
    r: 5.8
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "m297.56,413.07c-1.31,0-2.39-1.05-2.42-2.37-.41-22.17,5.43-42.71,14.89-52.35,7.6-7.74,16.97-7.76,24.58,0,9.46,9.64,15.3,30.18,14.89,52.35-.02,1.34-1.17,2.42-2.46,2.37-1.33-.03-2.4-1.13-2.37-2.46.39-20.93-4.91-40.12-13.51-48.87-5.69-5.8-11.99-5.8-17.68,0-8.59,8.76-13.9,27.94-13.5,48.87.03,1.35-1.06,2.46-2.42,2.46Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Inner_Logo-8",
    "data-name": "Inner Logo"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Square-8",
    "data-name": "Square",
    className: "cls-3",
    d: "m293.2,451.76v-10.72h56.06v56.06h-56.06v-9.83h-1.63v11.45h59.32v-59.32h-59.32v12.35h1.63Z"
  }), /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(290.16 476.12)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "INNER"))))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeliveryguywithrack);
export default __webpack_public_path__ + "static/media/Delivery guy with rack.e3c9c7845f5ef3e9f767f792c36c3576.svg";
export { ForwardRef as ReactComponent };